import { createApp } from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './routers';
// import store from './store';
import pinia from '@/store/index';
import { Quasar, Notify, AppFullscreen, Loading, Dialog } from 'quasar';
import quasarLang from 'quasar/lang/ko-KR';
import CODE_CONFIG from '@/helpers/krt-common-codes/code.config';
import MESSAGES_CONFIG from '@/helpers/utils';
import Vue3TouchEvents from 'vue3-touch-events';
import { addLicense } from '@amcharts/amcharts5';
import krtApi from '@/helpers/krt-api';

// scss
import './main.scss';
import './assets/stylesheet/font.scss';
import './assets/stylesheet/layout.scss';
import './assets/stylesheet/normalize.scss';
import './assets/stylesheet/common.scss';
// 큐뱅크 수식 관련 스타일
import './assets/stylesheet/neq.scss';

// Import Quasar css
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css';
import 'quasar/src/css/index.sass';
import '@/assets/stylesheet/animation.css';
// import '@/components/common.js';

import * as Sentry from '@sentry/vue';

const app = createApp(App);

// API
app.config.globalProperties.$krtApi = krtApi;

addLicense('AM5C371244502');

const { NODE_ENV, VUE_APP_VERSION, VUE_APP_SENTRY_DSN } = process.env;
const IgnoreErrors = [
	`ResizeObserver loop completed with undelivered notifications.`,
	`ResizeObserver loop limit exceeded`,
	`Cannot set properties of null (setting 'scrollTop')`,
	`MetaMask`,
];

/* const isInspectEnv = new URL(document.location).pathname?.includes('inspect');
!isInspectEnv && Sentry.init({
const isWebViewEnv =
    !!window.PanApp &&
    'ontouchstart' in window &&
    navigator.userAgent.includes('; wv)') &&
    /Android|SM-/i.test(navigator.userAgent);
isWebViewEnv && Sentry.init({ */

const exceptionClientWidth = evt => {
	const err = evt.exception?.values?.[0];
	const a = err?.type === 'TypeError';
	const b = err?.value?.includes('clientWidth');
	const c = evt.stacktrace?.frames?.some(f =>
		f.filename?.includes('quasar.esm')
	);
	return a && b && c ? true : false;
};

Sentry.init({
	app,
	dsn: VUE_APP_SENTRY_DSN,
	integrations: [
		Sentry.browserTracingIntegration(router),
		Sentry.replayIntegration({
			maskAllText: true,
			blockAllMedia: true,
		}),
	],
	tracesSampleRate: NODE_ENV === 'production' ? 0.05 : 0.5,
	replaysSessionSampleRate: NODE_ENV === 'production' ? 0.05 : 0.5,
	replaysOnErrorSampleRate: NODE_ENV === 'production' ? 0.05 : 0.5,
	environment: NODE_ENV,
	debug: NODE_ENV === 'production' ? false : true,
	release: VUE_APP_VERSION,
	serverName: 'krt-service',
	readTimeOut: 1000,
	connectionTimeout: 1000,
	attachStacktrace: true,
	ignoreErrors: IgnoreErrors,
	beforeSend(evt) {
		if (exceptionClientWidth(evt)) return null;
		return evt;
	},
});

// global defaults setting
app.config.globalProperties.$CURRENT_PROFILE = process.env.NODE_ENV;
app.config.globalProperties.$axios = axios;
// axios.defaults.baseURL = process.env.VUE_APP_DS_URL;

// Common Codes
app.config.globalProperties.$CODE = CODE_CONFIG;
// Common Messages
app.config.globalProperties.$MESSAGE = MESSAGES_CONFIG;
// app.config.globalProperties.$mmtext = common;

app
	.use(pinia)
	.use(router)
	.use(Quasar, {
		plugins: { Notify, AppFullscreen, Loading, Dialog }, // import Quasar plugins and add here
		lang: quasarLang,
	})
	.use(Vue3TouchEvents, {
		disableClick: true,
		touchClass: '',
		tapTolerance: 10,
		swipeTolerance: 30,
		longTapTimeInterval: 400,
	})
	.mount('#app');
